import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {AdminDashboardWrapper} from '../pages/dashboard/AdminDashboardWrapper'
// import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {CustomerRegister} from '../pages/customerRegister'
import {useAuth} from '../modules/auth/core/Auth'
import {Contact} from '../pages/contact/Contact'
import {Portfolio} from '../modules/apps/portfolio/Portfolio'
import {Reports} from '../pages/reports/Reports'
import {ValuationReportPage} from '../modules/apps/user-report/valuation/UserReportPage'
import {TransactionReportPage} from '../modules/apps/user-report/transaction/UserReportPage'
import {SystematicStatusReportPage} from '../pages/reports/systematic-status/UserReportPage'
import {Disclaimer} from '../pages/disclaimer/Disclaimer'
import {Privacy} from '../pages/privacy-policy/Privacy'
import {Terms} from '../pages/terms/Terms'
import {ProfitLossReportPage} from '../pages/reports/profit-loss/UserReportPage'
import {ELSSReportPage} from '../pages/reports/elss/UserReportPage'
import {SystematicPerformanceReportPage} from '../pages/reports/systematic-performance/UserReportPage'

//import {Redemption} from '../../app/modules/apps/user-redemption/UsersPage'

const PrivateRoutes = () => {
  const auth = useAuth()
  // const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const FundRequestWrapper = lazy(
    () => import('../pages/create-fund-request/select-fund/FundRequestWrapper')
  )
  const BuyMF_Wrapper = lazy(
    () => import('../pages/create-fund-request/buy-mutual-fund/BuyMF_Wrapper')
  )
  const SellMF_Wrapper = lazy(
    () => import('../pages/create-fund-request/sell-mutual-fund/SellMF_Wrapper')
  )
  const CheckoutBuyFundWrapper = lazy(
    () => import('../pages/create-fund-request/checkout-buy-fund/CheckoutBuyWrapper')
  )
  const CheckoutSellFundWrapper = lazy(
    () => import('../pages/create-fund-request/checkout-sell-fund/CheckoutSellWrapper')
  )
  const CheckoutSipWrapper = lazy(
    () => import('../pages/create-fund-request/checkout-sip/CheckoutSipWrapper')
  )
  const SipstopMf_Wrapper = lazy(
    () => import('../pages/create-fund-request/sip-stop/SipstopMf_Wrapper')
  )
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const RedemptionPage = lazy(() => import('../modules/apps/user-redemption/RedemptionPage'))
  const SipPage = lazy(() => import('../modules/apps/user-sip/SipPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const UsersInvest = lazy(() => import('../modules/apps/user-investment/UsersPage'))
  const Users = lazy(() => import('../modules/apps/users/UsersPage'))
  const Exchanges = lazy(() => import('../modules/apps/exchanges/ExchangePage'))
  const ExchangeType = lazy(() => import('../modules/apps/exchanges-types/ExchangeTypePage'))
  const ExchangeSubType = lazy(
    () => import('../modules/apps/exchanges-sub-types/ExchangeSubTypePage')
  )
  const Amc = lazy(() => import('../modules/apps/amc/AmcPage'))
  const Schemes = lazy(() => import('../modules/apps/schemes/SchemePage'))
  const UserReport = lazy(() => import('../modules/apps/user-report/UserReportWrapper'))
  const HelpSupport = lazy(() => import('../pages/help/HelpSupport'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
        {/* Pages */}
        <Route
          path='dashboard'
          element={
            auth.currentUser?.roleId === 1 ? <AdminDashboardWrapper /> : <DashboardWrapper />
          }
        />
        {/* <Route path='builder' element={<BuilderPageWrapper />} /> */}
        {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
        <Route path='help' element={<HelpSupport />} />
        <Route path='disclaimer' element={<Disclaimer />} />
        <Route path='privacy' element={<Privacy />} />
        <Route path='terms' element={<Terms />} />
        <Route path='contact-us' element={<Contact />} />
        <Route path='add-customer' element={<CustomerRegister />} />
        <Route path='create-fund-request' element={<FundRequestWrapper />} />
        <Route path='create-fund-request/buy-mutual-fund' element={<BuyMF_Wrapper />} />
        <Route
          path='create-fund-request/buy-mutual-fund/:id'
          element={<CheckoutBuyFundWrapper />}
        />
        <Route path='create-fund-request/sell-mutual-fund/*' element={<SellMF_Wrapper />} />
        <Route
          path='create-fund-request/sell-mutual-fund/:id'
          element={<CheckoutSellFundWrapper />}
        />
        <Route path='create-fund-request/sip-stop/*' element={<SipstopMf_Wrapper />} />
        <Route path='create-fund-request/sip-stop/:id' element={<CheckoutSipWrapper />} />
        <Route path='portfolio' element={<Portfolio />} />
        {/* Lazy Modules */}
        <Route
          path='profile/'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/'
          element={
            <SuspensedView>
              <Reports />
            </SuspensedView>
          }
        />
        <Route
          path='reports/current-holdings'
          element={
            <SuspensedView>
              <ValuationReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/transactions'
          element={
            <SuspensedView>
              <TransactionReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/systematic-status'
          element={
            <SuspensedView>
              <SystematicStatusReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/profit-loss'
          element={
            <SuspensedView>
              <ProfitLossReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/elss'
          element={
            <SuspensedView>
              <ELSSReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='reports/systematic-performance'
          element={
            <SuspensedView>
              <SystematicPerformanceReportPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='user-investments/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='user-investment/*'
          element={
            <SuspensedView>
              <UsersInvest />
            </SuspensedView>
          }
        />
        <Route
          path='user-redemption/*'
          element={
            <SuspensedView>
              <RedemptionPage />
            </SuspensedView>
          }
        />

        <Route
          path='user-sip/*'
          element={
            <SuspensedView>
              <SipPage />
            </SuspensedView>
          }
        />

        <Route
          path='exchanges/*'
          element={
            <SuspensedView>
              <Exchanges />
            </SuspensedView>
          }
        />
        <Route
          path='exchanges-type/*'
          element={
            <SuspensedView>
              <ExchangeType />
            </SuspensedView>
          }
        />
        <Route
          path='exchanges-sub-types/*'
          element={
            <SuspensedView>
              <ExchangeSubType />
            </SuspensedView>
          }
        />
        <Route
          path='amc/*'
          element={
            <SuspensedView>
              <Amc />
            </SuspensedView>
          }
        />
        <Route
          path='schemes/*'
          element={
            <SuspensedView>
              <Schemes />
            </SuspensedView>
          }
        />
        <Route
          path='users/*'
          element={
            <SuspensedView>
              <Users />
            </SuspensedView>
          }
        />
        <Route
          path='users/generate-customer-report'
          element={
            <SuspensedView>
              <UserReport />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/dashboard' />} />
      </Route>
    </Routes>
  )
}

interface SuspensedViewProps {
  children: React.ReactNode
}

const SuspensedView: FC<SuspensedViewProps> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
